import { AppBar, Hidden, IconButton, SvgIcon, Toolbar, makeStyles, } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import Logo from "../Logo";
export const APP_TOP_BAR_HEIGHT = 64;
const useStyles = makeStyles((theme) => ({
    root: {
        zIndex: theme.zIndex.drawer + 100,
        boxShadow: "none",
        backgroundColor: theme.palette.primary.main,
    },
    toolbar: {
        minHeight: APP_TOP_BAR_HEIGHT,
        height: APP_TOP_BAR_HEIGHT,
    },
}));
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const TopBar = ({ className, onMobileNavOpen, ...rest }) => {
    const classes = useStyles();
    return (React.createElement(AppBar, { className: classes.root, ...rest },
        React.createElement(Toolbar, { className: classes.toolbar },
            React.createElement(Hidden, { lgUp: true },
                React.createElement(IconButton, { color: "inherit", onClick: onMobileNavOpen },
                    React.createElement(SvgIcon, null,
                        React.createElement(MenuIcon, null)))),
            React.createElement(Hidden, { mdDown: true },
                React.createElement(RouterLink, { to: "/" },
                    React.createElement(Logo, { width: 170 }))))));
};
TopBar.defaultProps = {
    className: undefined,
    onMobileNavOpen: () => { },
};
export default TopBar;
//# sourceMappingURL=index.js.map